<script>
// Mixins
import { factory as GroupableFactory } from "@mixins/groupable";
import Routable from "@mixins/routable";

// Utilities
import { keyCodes } from "@/core/util/helpers";
import mixins from "@/core/util/mixins";

const baseMixins = mixins(Routable, GroupableFactory("tabsBar"));

export default baseMixins.extend({
  name: "Tab",

  data: () => ({
    proxyClass: "tab_active"
  }),

  computed: {
    classes() {
      return {
        tab: true,
        ...Routable.computed.classes.call(this),
        tab_disabled: this.disabled
      };
    },
    value() {
      let to = this.to || this.href || "";

      if (this.$router && this.to === Object(this.to)) {
        const resolve = this.$router.resolve(this.to, this.$route, this.append);

        to = resolve.href;
      }

      return to.replace("#", "");
    }
  },

  // mounted () {
  //   this.onRouteChange()
  // },

  methods: {
    click(e) {
      // If user provides an
      // actual link, do not
      // prevent default
      if (this.href && this.href.indexOf("#") > -1) e.preventDefault();

      if (e.detail) this.$el.blur();

      this.$emit("click", e);

      this.to || this.toggle();
    }
  },

  render(h) {
    const { tag, data } = this.generateRouteLink();

    data.attrs = {
      ...data.attrs,
      "aria-selected": String(this.isActive),
      role: "tab",
      tabindex: 0
    };
    data.on = {
      ...data.on,
      keydown: e => {
        if (e.keyCode === keyCodes.enter) this.click(e);

        this.$emit("keydown", e);
      }
    };

    return h(tag, data, this.$slots.default);
  }
});
</script>

<style lang="scss" scoped>
.tab {
  flex: 0 0 50%;
  max-width: 50%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(#000a25, 0.5);
  color: #fff;
  font-weight: bold;
  font-size: 18px;
  line-height: 1.5;
  letter-spacing: 0.02em;
  transition: $primary-transition;

  &_active {
    background: transparent;
    color: #fbc33e;
  }

  @include breakpoint("xs-only") {
    font-size: 14px;
  }
}
</style>
